// START_MODULE pages_news_header_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';
import styled, { css } from 'styled-components';
import { useNavigate } from 'react-router-dom';

import logo from 'assets/logoWithoutText.svg';
import logoText from 'assets/logoText.svg';

import ArrowLeft from 'components/atoms/icons/ArrowLeft';
import Button from 'components/atoms/button/Button';

import { route } from 'routes/route';

interface HeaderProps {
  list?: boolean;
}

const Header: React.FC<HeaderProps> = ({ list = true }) => {
  const navigate = useNavigate();

  return (
    <HeaderWrapper>
      <BackButton onClick={() => navigate(list ? route.base : route.news)}>
        <ArrowLeft />
        {list ? 'На главную страницу' : 'К списку новостей'}
      </BackButton>
      <HeaderText>
        <Logo src={logo} />
        <LogoText src={logoText} />
      </HeaderText>
      <SubHeader>Новости</SubHeader>
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.div`
  padding: 12px;
  margin-bottom: 8px;

  position: relative;
`;

const HeaderText = styled.header`
  ${({ theme }) => css`
    margin: 0 auto 8px auto;
    width: fit-content;

    display:flex;
    align-items: center;
    gap: 12px;

    h1 {
      font-size: 2rem;
      font-family: ${theme.accentFontFamily};
    }

    @media (max-width: 920px) {
      margin-top: 70px;
    }
  `};
`;

const SubHeader = styled.h2`
  text-align: center;
  font-size: 1.8rem;
`;

const Logo = styled.img`
  width: 40px;
  height: 40px;
`;

const LogoText = styled.img`
  height: 20px;
`;

const BackButton = styled(Button)`
  position: absolute;
  top: 12px;
  left: 12px;
`;

export default Header;

// END_MODULE pages_news_header_tsx
